import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import './styles/financial-pages.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NotificationProvider } from './components/notification/NotificationProvider';

import { useDispatch, useSelector } from 'react-redux';

import LoginPage from './pages/LoginPage';

import ProtectedRoute from './ProtectedRoute';
import Layout from './components/layout/Layout';
import { protectedRoutes } from './routesConfig';
import { logout } from './store/authSlice';

function App() {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.access_token);
  const isAuthenticated = Boolean(accessToken || localStorage.getItem('access_token'));

  const handleLogout = () => {
    dispatch(logout());
  };

  const renderProtectedRoute = (Component) => (
    <ProtectedRoute isAuthenticated={isAuthenticated}>
      <Layout onLogout={handleLogout}>
        <Component />
      </Layout>
    </ProtectedRoute>
  );

  return (
    <NotificationProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
            />
            <Route
              path="/register"
              element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />}
            />
            <Route
              path="/"
              element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />}
            />
            {protectedRoutes.map(({ path, component: Component }) => (
              <Route
                key={path}
                path={path}
                element={renderProtectedRoute(Component)}
              />
            ))}
            <Route
              path="*"
              element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </NotificationProvider>
  );
}

export default App;
